import React, {FunctionComponent} from "react";
import useStore from '@App/store'

interface SelectDropdownItem {
    id: string
    name: string
    slug?: string
    important?: boolean
}

type SelectDropdownProps = {
    values: any
    placeholdertext: string
    id: string
    onChange: (e: string) => void
    value: string
};

export const SelectDropdown: FunctionComponent<SelectDropdownProps> = ((props: SelectDropdownProps) => {

    const state = useStore()

    return (
        <select
            id={props.value}
            name={props.value}
            value={props.value}
            onChange={(e) => props.onChange(e.target.value)}
            disabled={!props.values}
            className={`selectDropdown relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full px-4 py-2 mb-2 pr-6 text-gray-700`}>
                <option value={props.id} disabled>{props.placeholdertext}</option>
                {props.values && props.values.map((val: any) => (
                        <option key={val.id} value={val.id}>{val.formatted_name ? val.formatted_name : val.name}</option>
                    )
                )}
        </select>
    );
})
